import {
  APP_SET_LOGIN_STATE,
  APP_SET_WINDOW_SIZE,
} from "./types";

export const actionApp_setLoginState = data => ({
  type: APP_SET_LOGIN_STATE,
  data
});

export const actionApp_setWindowSize = data => ({
  type: APP_SET_WINDOW_SIZE,
  data
});